module.exports = __webpack_public_path__ + "static/img/video-pass-off.b5fcccc7.png";